import React, {Component} from 'react';
import {FormControl, InputLabel, MenuItem, Select} from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';
//import Flag from 'react-world-flags';
import {withTranslation} from "react-i18next";
import CzechFlag from "../../components/flags/CzechFlag";
import EnglandFlag from "../../components/flags/EnglandFlag";
import GermanyFlag from "../../components/flags/GermanyFlag";

const styles = theme => ({
    formControl: {
        minWidth: 120
    },
    flagIcon: {
        height: 16,
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
    }
});

class LanguageSelect extends Component {
    handleChange = (e) => {
        if (this.props.onLanguageSelected) {
            this.props.onLanguageSelected(e.target.value);
        }
    };

    render() {
        const {classes, t, language} = this.props;
        const languageList = [
            {flag: 'cz', code: 'cs', name: 'Česky', altFlag: <CzechFlag className={classes.flagIcon} />},
            {flag: 'gb', code: 'en', name: 'English', altFlag: <EnglandFlag className={classes.flagIcon} />},
            {flag: 'de', code: 'de', name: 'Deutsche', altFlag: <GermanyFlag className={classes.flagIcon} />}
        ];

        const selectItems = languageList.map(item => {
//            const flag = item.altFlag ? item.altFlag : <Flag className={classes.flagIcon} code={item.flag} />;
            const flag = item.altFlag;
            return <MenuItem key={item.code} value={item.code}>{flag}{item.name}</MenuItem>;
        });

        return (
            <FormControl margin="normal" fullWidth className={classes.formControl}>
                <InputLabel shrink>
                    {t('language')}
                </InputLabel>
                <Select
                    value={language}
                    onChange={(e) => this.handleChange(e)}
                    name="language">
                    {selectItems}
                </Select>
            </FormControl>
        );
    }
}

export default withStyles(styles)(withTranslation('messages')(LanguageSelect));